import {store} from "../../store/store";

export const ClipboardService = {
    addDay(day, metadata) {
      const key = this.createKey('day');
      localStorage.setItem(key, JSON.stringify({
          day: day,
          metadata: metadata,
      }));
    },

    getDay() {
        const key = this.createKey('day');
        return JSON.parse(localStorage.getItem(key));
    },

    hasDay() {
        return store.state.clipboard.day !== null;
    },

    removeDay() {
        store.state.clipboard.day = null;
        localStorage.removeItem(this.createKey('day'));
    },

    addPlan(plan, metadata) {
        const key = this.createKey('plan');
        localStorage.setItem(key, JSON.stringify({
            plan: plan,
            metadata: metadata,
        }));
    },

    getPlan() {
        const key = this.createKey('plan');
        return JSON.parse(localStorage.getItem(key));
    },

    hasPlan() {
        return store.state.clipboard.plan !== null;
    },

    removePlan() {
        store.state.clipboard.plan = null;
        localStorage.removeItem(this.createKey('plan'));
    },

    createKey(key) {
        return `${currentUser.id}_${key}`;
    }
};
